import type { BrandConfig } from './types';

export const arkConfig: BrandConfig = {
  key: 'ark',
  isDefault: false,
  subdomain: 'film.wjark',
  logo: '/brands/ark/logo.png',
  title: '方舟 AI 影视 - 让每一个创意，都成为电影。',
  siteName: '方舟 AI 影视',
  allowedCreationTabs: ['text', 'image', 'video', 'tools'],
  payment: {
    productName: '方舟 AI 影视平台付费服务协议',
    productNameKey: 'payment.arkProductName',
  },
  agreementTabs: [
    { key: 'user-agreement', label: '方舟 AI 影视平台付费协议', labelKey: 'agreement.tabArkPayment' },
    { key: 'ricegrain-rules', label: '米粒值规则说明', labelKey: 'agreement.tabRiceGrain' },
    { key: 'privacy-policy', label: '用户协议及隐私政策', labelKey: 'agreement.tabPrivacy' },
    { key: 'enterprise-service-agreement', label: '企业服务协议', labelKey: 'agreement.tabEnterprise' },
  ],
  logoDisplay: {
    mode: 'image-text',
    image: '/brands/ark/logo.png',
    text: '方舟 AI 影视',
    showGlow: false,
    imageStyle: { width: '32px', height: '32px' },
    textStyle: { fontSize: '16px', fontWeight: '500' },
  },
};
